import { getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";
import BaseService from "../base.service";

class SurveyAlert extends BaseService {
  constructor() {
    super("survey-alerts");
  }

  upsertOne(surveyAlertData) {
    return getResponseQuery(
      http.post(`${this.path}/upsert-one`, surveyAlertData)
    );
  }

  getByAssignedEmployee(assignedEmployee, params = {}) {
    return getResponseQuery(
      http.get(`${this.path}/get-by-assigned-employee/${assignedEmployee}`, {
        params
      })
    );
  }

  checkDuplication(assignedEmployee, surveyDates = [], excludeId = "") {
    return getResponseQuery(
      http.post(`${this.path}/check-duplication`, {
        assignedEmployee,
        surveyDates,
        excludeId
      })
    );
  }
}

export default new SurveyAlert();
